import {
    useCallback,
} from 'react'
import {
    FormHelperText,
} from '@mui/material'
import {
    MobileDatePicker,
} from '@mui/x-date-pickers/MobileDatePicker'
import clsx from 'clsx'

import Label from 'app/shared-components/Label'
import {
    dateToDateStr,
    strToMoment,
} from 'app/utils/date'

import ToolbarWithKeyboardViewSwitch from '../DateTimeZonedSelect/components/ToolbarWithKeyboardViewSwitch'
import LayoutWithKeyboardView from '../DateTimeZonedSelect/components/LayoutWithKeyboardView'
import InputSingleline from '../InputSingleline'
import useStyles from './DateSelect.styles'

type Props = {
    title?: string,
    name?: string,
    hasError?: string,
    onChange: (value: string, event: any) => void,
    disabled?: boolean,
    required?: boolean,
    value?: string,
    className?: string,
    disablePast?: boolean,
}

const DateSelect = ({
    title = '',
    name = '',
    hasError = '',
    onChange,
    value = null,
    disabled = false,
    required = false,
    className = '',
    disablePast = false,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()

    const handleOnChange = useCallback((date) => {
        const newValue = dateToDateStr(date)

        onChange(newValue, {
            target: {
                name,
                value: newValue,
            },
        })
    }, [
        name,
        onChange,
    ])

    if (disabled) {
        return (
            <InputSingleline
                name={name}
                title={title}
                value={value}
                disabled
            />
        )
    }

    return (
        <div
            className={className}
            data-testid={`dateSelect-${name}`}
        >
            <Label
                title={title}
                hasError={hasError}
            />
            <div
                className={clsx(
                    classes.dateField,
                    {
                        [classes.isRequired]: required,
                    },
                )}
            >
                {required && (
                    <div
                        className={classes.requiredMark}
                        data-testid="dateSelect-required-mark"
                    />
                )}
                <MobileDatePicker
                    className={classes.input}
                    value={strToMoment(value)}
                    format="DD.MM.YYYY"
                    onChange={handleOnChange}
                    slotProps={{
                        textField: {
                            variant: 'standard',
                            fullWidth: true,
                        },
                    }}
                    slots={{
                        layout: LayoutWithKeyboardView,
                        toolbar: ToolbarWithKeyboardViewSwitch,
                    }}
                    disablePast={disablePast}
                    disableOpenPicker
                />
                <FormHelperText
                    error={Boolean(hasError)}
                    className={classes.errorMessage}
                >
                    {hasError}
                </FormHelperText>
            </div>
        </div>
    )
}

export default DateSelect
